/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';
import type { MarketingDomainAuditRowData } from './MarketingDomainAuditRowData';
import {
    MarketingDomainAuditRowDataFromJSON,
    MarketingDomainAuditRowDataFromJSONTyped,
    MarketingDomainAuditRowDataToJSON,
    MarketingDomainAuditRowDataToJSONTyped,
} from './MarketingDomainAuditRowData';

/**
 * 
 * @export
 * @interface MarketingDomainAuditData
 */
export interface MarketingDomainAuditData {
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditData
     */
    campaignsWithoutDomain?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditData
     */
    adsWithoutDomain?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditData
     */
    campaignsOnDisabledDomains?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingDomainAuditData
     */
    adsOnDisabledDomains?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingDomainAuditData
     */
    spendWithoutDomain?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingDomainAuditData
     */
    spendOnDisabledDomains?: MoneyOutput;
    /**
     * 
     * @type {Array<MarketingDomainAuditRowData>}
     * @memberof MarketingDomainAuditData
     */
    rows?: Array<MarketingDomainAuditRowData>;
    /**
     * Canonical connected-provider spend in the project currency for the requested date and domain scope. Campaign insights take precedence over ad insights for each campaign and day.
     * @type {MoneyOutput}
     * @memberof MarketingDomainAuditData
     */
    canonicalConnectedSpend?: MoneyOutput;
    /**
     * Signed difference between canonicalConnectedSpend and the sum of the existing effective domain rows in the same scope. The difference is not attributed to a domain, does not identify its cause, and does not imply source completeness.
     * @type {MoneyOutput}
     * @memberof MarketingDomainAuditData
     */
    coverageResidual?: MoneyOutput;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof MarketingDomainAuditData
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {MarketingDomainAuditDataFinanceScopeEnum}
     * @memberof MarketingDomainAuditData
     */
    financeScope?: MarketingDomainAuditDataFinanceScopeEnum;
    /**
     * 
     * @type {MarketingDomainAuditDataCanonicalConnectedSpendScopeEnum}
     * @memberof MarketingDomainAuditData
     */
    canonicalConnectedSpendScope?: MarketingDomainAuditDataCanonicalConnectedSpendScopeEnum;
}


/**
 * @export
 */
export const MarketingDomainAuditDataFinanceScopeEnum = {
    RawProvider: 'raw_provider'
} as const;
export type MarketingDomainAuditDataFinanceScopeEnum = typeof MarketingDomainAuditDataFinanceScopeEnum[keyof typeof MarketingDomainAuditDataFinanceScopeEnum];

/**
 * @export
 */
export const MarketingDomainAuditDataCanonicalConnectedSpendScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type MarketingDomainAuditDataCanonicalConnectedSpendScopeEnum = typeof MarketingDomainAuditDataCanonicalConnectedSpendScopeEnum[keyof typeof MarketingDomainAuditDataCanonicalConnectedSpendScopeEnum];


/**
 * Check if a given object implements the MarketingDomainAuditData interface.
 */
export function instanceOfMarketingDomainAuditData(value: object): value is MarketingDomainAuditData {
    return true;
}

export function MarketingDomainAuditDataFromJSON(json: any): MarketingDomainAuditData {
    return MarketingDomainAuditDataFromJSONTyped(json, false);
}

export function MarketingDomainAuditDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingDomainAuditData {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignsWithoutDomain': json['campaignsWithoutDomain'] == null ? undefined : json['campaignsWithoutDomain'],
        'adsWithoutDomain': json['adsWithoutDomain'] == null ? undefined : json['adsWithoutDomain'],
        'campaignsOnDisabledDomains': json['campaignsOnDisabledDomains'] == null ? undefined : json['campaignsOnDisabledDomains'],
        'adsOnDisabledDomains': json['adsOnDisabledDomains'] == null ? undefined : json['adsOnDisabledDomains'],
        'spendWithoutDomain': json['spendWithoutDomain'] == null ? undefined : MoneyOutputFromJSON(json['spendWithoutDomain']),
        'spendOnDisabledDomains': json['spendOnDisabledDomains'] == null ? undefined : MoneyOutputFromJSON(json['spendOnDisabledDomains']),
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(MarketingDomainAuditRowDataFromJSON)),
        'canonicalConnectedSpend': json['canonicalConnectedSpend'] == null ? undefined : MoneyOutputFromJSON(json['canonicalConnectedSpend']),
        'coverageResidual': json['coverageResidual'] == null ? undefined : MoneyOutputFromJSON(json['coverageResidual']),
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
        'canonicalConnectedSpendScope': json['canonicalConnectedSpendScope'] == null ? undefined : json['canonicalConnectedSpendScope'],
    };
}

export function MarketingDomainAuditDataToJSON(json: any): MarketingDomainAuditData {
    return MarketingDomainAuditDataToJSONTyped(json, false);
}

export function MarketingDomainAuditDataToJSONTyped(value?: MarketingDomainAuditData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'campaignsWithoutDomain': value['campaignsWithoutDomain'],
        'adsWithoutDomain': value['adsWithoutDomain'],
        'campaignsOnDisabledDomains': value['campaignsOnDisabledDomains'],
        'adsOnDisabledDomains': value['adsOnDisabledDomains'],
        'spendWithoutDomain': MoneyOutputToJSON(value['spendWithoutDomain']),
        'spendOnDisabledDomains': MoneyOutputToJSON(value['spendOnDisabledDomains']),
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(MarketingDomainAuditRowDataToJSON)),
        'canonicalConnectedSpend': MoneyOutputToJSON(value['canonicalConnectedSpend']),
        'coverageResidual': MoneyOutputToJSON(value['coverageResidual']),
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
        'canonicalConnectedSpendScope': value['canonicalConnectedSpendScope'],
    };
}

